import { render } from "./TheVehicleModelVehicles.vue?vue&type=template&id=a4620292"
import script from "./TheVehicleModelVehicles.vue?vue&type=script&lang=js"
export * from "./TheVehicleModelVehicles.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__